import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Divider, Empty, Card, Statistic, Tooltip } from "antd";
//import moment from "moment";
//import { useDispatch } from "react-redux";
//import { figurenames, figures } from "../../constants";

// Styles
import { Wrapper, ThreeBox, FigureInfomationWrapper } from "./styles";

// Hooks
import useProcessDesings from "../../hooks/useProcessDesings";
import useManufacturingOrder from '../../hooks/useManufacturingOrder';

import ThreeFigure from "../../components/three-figure";
import Table from "../../components/table";
import Search from "../../components/table/search";

import { secons2Dhm } from "../../services/timeFunctions";

import ModalDesingAddArticle from './modalDesing'
import ModalDesingExtraData from "../../components/modal-desing-process";

import { grades } from "../../constants";

//import multilanguage library
import { useTranslation } from 'react-i18next'

// Components
//import ThreeFigure from "../../components/three-figure";


//import { grades } from "../../constants";

const RenderManufacturingOrder = ({ changeTitle }) => {
  //const [state, setState] = useState(desing);
  const [listOfManufacturing, setListOfManufacturing] = useState([]);
  const [selectedManufacturing, setSelectedManufacturing] = useState(null);
  const [selectedRowKeyManufacturing, setSelectedRowKeyManufacturing] = useState([]);

  const [showModalDesingAddArticle, setShowModalDesingAddArticle] = useState(false);


  const [showModalExtraData, setShowModalExtraData] = useState(false);
  

  //const dispath = useDispatch();

  const { manufacturingOrder, updateData } = useManufacturingOrder();
  const { processDesings } = useProcessDesings();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("manufacturig_order");
  }, [changeTitle]);


  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => !order.making);
    
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order
      };
    });

    normalized && setListOfManufacturing(normalized)

    if(normalized && normalized[0])  {
      setSelectedManufacturing(normalized[0]);
      setSelectedRowKeyManufacturing([normalized[0].key]);
    }
  }, [manufacturingOrder]);


  const columnsManufacturing = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend",
      ...Search("ref")
    },
    {
      title: t('table.header.article'),
      dataIndex: "article.articleName",
      key: "article.articleName"
    },
    {
      title: t('table.header.n_articles'),
      dataIndex: "articlesNumber",
      key: "articlesNumber",
      sorter: (a, b) => a.articlesNumber-b.articlesNumber
    },
    {
      title: t('table.header.design'),
      dataIndex: "desing.desingName",
      key: "desing",
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip style={{cursor: "pointer"}} onClick={() => !record.making && setShowModalDesingAddArticle(true)} title={record.making ? t('button.action.manufacturing_in_progress') : t('button.action.link_design')}>
            <Icon type="link" style={{ color: record.making ? "#ccc" : "#3498db", cursor: "pointer" }} />{" "}
            {record.desing ? <span style={{ color: "#3498db", cursor: "pointer" }}>{record.desing.desingName}</span> : <span style={{ cursor: "pointer" }}>{t('button.action.not_linked')}</span>}
          </Tooltip>
        </Row>
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys: selectedRowKeyManufacturing,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeyManufacturing(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedManufacturing(listOfManufacturing.find(obj => obj.id === record.id));
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
    type: "radio"
  };
  
  const clickRow = row => {
    setSelectedRowKeyManufacturing([row.key]);
    setSelectedManufacturing(listOfManufacturing.find(obj => obj.id === row.id));
  };
  
  const gradeText = selectedManufacturing && selectedManufacturing.article && grades.find(grade => grade.value === selectedManufacturing.article.grade).name;
  const figureEntries = selectedManufacturing && selectedManufacturing.article && Object.entries(selectedManufacturing.article.figure[0].values);
  
  const handleShowModalDesingAddArticle = visible => setShowModalDesingAddArticle(visible);
  const handleShowModalExtraData = visible => setShowModalExtraData(visible);

  
  const setLink = (id) => {
      let copy = manufacturingOrder.find(obj => obj.id === selectedManufacturing.id)
      copy.desingId = id;
      copy.desing = processDesings.find(obj => obj.id === id);
      updateData(copy)
  }

  const RenderDesingData = ({selectedProcessDesing}) => (<FigureInfomationWrapper>
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col span={8}>
        <h3>{t('phase.furnace')}</h3>
        <Col span={24}>
          <Statistic
            title={t('labels.temperature')}
            value={selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.temperature}
            suffix="ºC"
          />
        </Col>
        <Col span={24}>
          <Statistic
            title={t('labels.time_d_hh_mm')}
            value={
              selectedProcessDesing &&
              selectedProcessDesing.recommendation &&
              selectedProcessDesing.recommendation.furnace_time &&
              secons2Dhm(selectedProcessDesing.recommendation.furnace_time)
            }
          />
        </Col>
      </Col>

      <Col span={8}>
        <h3>{t('phase.quenching')}</h3>
        <Col span={24}>
          <Statistic
            title={t('labels.temperature')}
            value={selectedProcessDesing && selectedProcessDesing.quenching && selectedProcessDesing.quenching.bath_temperature}
            suffix="ºC"
          />
        </Col>
        <Col span={24}>
          <Statistic
            title={t('labels.tempered_coat')}
            value={selectedProcessDesing && selectedProcessDesing.recommendation && selectedProcessDesing.recommendation.quenching}
            suffix="mm"
          />
        </Col>
      </Col>

      <Col span={8}>
        <h3>{t('phase.tempered')}</h3>
        <Col span={24}>
          <Statistic
            title={t('labels.temperature')}
            value={selectedProcessDesing && selectedProcessDesing.tempered && selectedProcessDesing.tempered.temperature}
            suffix="ºC"
          />
        </Col>
        <Col span={24}>
          <Statistic
            title={t('labels.time_d_hh_mm')}
            value={
              selectedProcessDesing &&
              selectedProcessDesing.recommendation &&
              selectedProcessDesing.recommendation.tempered_time &&
              secons2Dhm(selectedProcessDesing.recommendation.tempered_time)
            }
          />
        </Col>
      </Col>
    </Row>
  </FigureInfomationWrapper>);

  return (
    <Wrapper>
      <Row style={{ margin: 0, height: "100%" }} gutter={[16, 16]}>
        <Col xl={12} lg={12} md={24}>
            <Table data={listOfManufacturing} columns={columnsManufacturing} rowSelection={rowSelection} onClick={() => clickRow} />
        </Col>
        <Col xl={12} lg={12} md={24} style={{ margin: 0 }}>
        
          <Card
            title={
              (selectedManufacturing && selectedManufacturing.ref ? selectedManufacturing.ref : "")
              + "-" +
              (selectedManufacturing && selectedManufacturing.article && selectedManufacturing.article.articleName ? selectedManufacturing.article.articleName : "")
              + "-" +
              (selectedManufacturing && selectedManufacturing.desing && selectedManufacturing.desing.desingName ? selectedManufacturing.desing.desingName : t('button.action.not_linked') )
            }
            actions={[
              <span onClick={() => setShowModalExtraData(true)}>
                <Icon type="eye" key="eye" /> {t('button.more_info')}
              </span>
            ]}
          >
            <Row style={{ margin: 0 }} gutter={[16, 16]}>
              <Col xl={12} lg={12} md={24}>
              <FigureInfomationWrapper>
               {gradeText && (<Col span={16} key="grado_acero">
                  <Statistic title={t('labels.steel_grade')} value={gradeText} suffix="" precision={0} />
                </Col>)}
               {selectedManufacturing && selectedManufacturing.article && selectedManufacturing.article.hard_coat && (<Col span={8} key="capa_dura">
                  <Statistic title={t('labels.hard_coat')} value={selectedManufacturing.article.hard_coat} suffix=" mm" />
                </Col>)}
                {selectedManufacturing && selectedManufacturing.article &&
                  figureEntries.map(([key, value], index) => (
                    <Col span={8} key={index}>
                      <Statistic
                        title={t('labels.measurements.'+key)}
                        value={value}
                        precision={0}
                        suffix=" mm"
                        formatter={value => value && value.toString().replace(",", "")}
                      />
                    </Col>
                  ))}
              </FigureInfomationWrapper>            
            </Col>
              <Col xl={12} lg={12} md={24}>
                  <ThreeBox>
                    {selectedManufacturing && selectedManufacturing.article && selectedManufacturing.article.figure[0] && <ThreeFigure figureData={selectedManufacturing.article.figure[0]} />}
                  </ThreeBox>
              </Col>
            </Row>
            <Divider></Divider>
            <Row style={{ margin: 0 }} gutter={[16, 16]}>
              <Col xl={24} lg={24} md={24}>
                {selectedManufacturing && selectedManufacturing.desing ? 
                  <RenderDesingData selectedProcessDesing={selectedManufacturing.desing} />
                  :
                  <Empty
                  //image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
                  image={<Icon type="disconnect" style={{ fontSize: 120 }} />}
                  imageStyle={{
                      height: 120,
                    }}
                    description={
                      <h3>
                        {t('text.design_no_linked')}
                      </h3>
                    }
                  >
                    {t('text.text_no_linked')}
                  </Empty>
                }
              </Col>
            </Row>
          </Card>
        </Col>
        <ModalDesingAddArticle visible={showModalDesingAddArticle} handleVisible={handleShowModalDesingAddArticle} article={selectedManufacturing && selectedManufacturing.article} setLink={setLink} />
        <ModalDesingExtraData visible={showModalExtraData} handleVisible={handleShowModalExtraData} desing={selectedManufacturing && selectedManufacturing.desing ? selectedManufacturing.desing: selectedManufacturing} />
      </Row>
    </Wrapper>
  );
};
export default RenderManufacturingOrder;
